import { TooltipProps } from './interfaces/TooltipProps';

export enum Direction {
	UP = 'UP',
	DOWN = 'DOWN',
}

export const directionClass: Record<Direction, string> = {
	[Direction.UP]: `after:top-full after:border-t-blue-grey-darkest 
						after:border-b-transparent`,
	[Direction.DOWN]: `after:bottom-full after:border-b-blue-grey-darkest 
						after:border-t-transparent`,
};

export default function Tooltip({ displayText, children, className, direction = Direction.DOWN }: TooltipProps) {
	return (
		<div className='relative inline-block group' data-testid='tooltip-block'>
			{displayText}
			<span
				className={`${className} ${directionClass[direction]} max-w-[90vw] absolute hidden group-hover:inline px-4 
					py-2 text-white bg-blue-grey-darkest rounded text-sm font-semibold 
					z-20 after:content-[''] top-[calc(100%+16px)] after:absolute
					after:-translate-x-1/2 after:border-4 after:border-x-transparent text-left `}>
				{children}
			</span>
		</div>
	);
}
